// <pitch-status-icon status="{{story.websked.pitch.pitchStatus}}"></pitch-status-icon>

function directive() {
  function link($scope, element, attrs) {
    const scope = $scope;
    // This pulls the 'status' attribute in for use in the template
    attrs.$observe('status', (status) => {
      switch (status) {
        case 'pitched':
          scope.icon = 'flag';
          break;
        case 'not watching':
          scope.icon = 'eye-slash';
          break;
        case 'watching':
          scope.icon = 'eye';
          break;
        case 'saving':
          scope.icon = 'thumb-tack';
          break;
        case 'used':
          scope.icon = 'check-circle';
          break;
        case 'withdrawn':
          scope.icon = 'flag-o';
          break;
        case 'booked':
          scope.icon = 'thumbs-o-up';
          break;
        case 'declined':
          scope.icon = 'thumbs-down';
          break;
        default:
          scope.icon = 'question';
          break;
      }
    });
  }

  return {
    restrict: 'E',
    scope: {},
    template: '<i class="fa fa-{{icon}}"></i>',
    link
  };
}

export default function (ngModule) {
  ngModule.directive('pitchStatusIcon', directive);
}
